module.exports = __webpack_public_path__ + "5f53f8958fe3be4e28170eea8b651a07.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ClanWebPro-News.woff
// module id = 620
// module chunks = 0